export default "__VITE_ASSET__BLpMVCH$__"